module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-fill-89d162d2.svg";